<div
  class="header-menu-container mb-4 pt-4 px-4"
  fxLayout="column"
  fxLayoutGap="5"
  *ngIf="authenticator.route !== 'authenticated'"
>
  <a [routerLink]="'/founders'" mat-flat-button color="primary">{{
    "HEADER.BTN.MENU_TITLES.ABOUT" | translate
  }}</a>
  <a [routerLink]="'/modules'" mat-flat-button color="primary">{{
    "HEADER.BTN.MENU_TITLES.MODULES" | translate
  }}</a>
  <a [routerLink]="'/prices'" mat-flat-button color="primary">{{
    "HEADER.BTN.MENU_TITLES.PRICES" | translate
  }}</a>
  <a [routerLink]="'/contact'" mat-flat-button color="primary">{{
    "HEADER.BTN.MENU_TITLES.CONTACT" | translate
  }}</a>
</div>

<app-sidenav-menu
  *ngIf="authenticator.route === 'authenticated'; else unauthenticated"
></app-sidenav-menu>

<ng-template #unauthenticated>
  <div class="easylot-sidenav">
    <!-- Sidenav widgets -->

    <div class="d-flex flex-column gap-3 mt-4">
      <!-- Sidenav join block -->
      <app-sidenav-menu-title
        [value]="'SIDENAV.JOIN_BLOCK.CAPTION' | translate"
      ></app-sidenav-menu-title>

      <app-sidenav-join-block
        [merchantCount]="merchantCount$ | async"
      ></app-sidenav-join-block>
      <!-- !Sidenav join block -->

      <!-- Sidenav newsletter block -->
      <app-sidenav-menu-title
        [value]="'SIDENAV.NEWSLETTER_BLOCK.CAPTION' | translate"
      ></app-sidenav-menu-title>

      <app-newsletter-block class="px-2"></app-newsletter-block>
      <!-- !Sidenav newsletter block -->

      <!-- Sidenav blog block -->
      <app-sidenav-menu-title
        [value]="'SIDENAV.BLOG_BLOCK.CAPTION' | translate"
        *ngIf="blogEnabled"
      ></app-sidenav-menu-title>

      <app-sidenav-blog-block *ngIf="blogEnabled"></app-sidenav-blog-block>

      <!-- Sidenav social platforms block -->
      <app-sidenav-menu-title
        [value]="'SIDENAV.SOCIAL_PLATFORMS_BLOCK.CAPTION' | translate"
      ></app-sidenav-menu-title>

      <app-sidenav-social-platforms-block></app-sidenav-social-platforms-block>
      <!-- !Sidenav social platforms block -->

      <a
        class="d-flex justify-content-center"
        href="https://www.gs1hu.org/"
        target="_blank"
      >
        <img height="200" src="assets/pics/GS1.png" alt="gs1_logo" />
      </a>
    </div>
    <!-- !Sidenav widgets -->
  </div>
</ng-template>
<!--</div>-->
